import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Dropdown, Menu, message, Modal } from 'antd';
import classnames from 'classnames';
import { apiHolder as api, apis, getDingTalkSearchString, getFeiShuUrl, COPIED_ATTACH_KEY, } from 'api';
import IconCard from '../IconCard';
import { decodeAttFileName, formatFileSize, getSuffix } from '@web-common/components/util/file';
import SiriusMessage from '../Message/SiriusMessage';
import ImgPreview from '../ImagePreview';
import useSingleAndDoubleClick from '@web-common/hooks/useDoubleClick';
import styles from './index.module.scss';
import Alert from '@web-common/components/UI/Alert/Alert';
import { FormatExpiredDate } from '@web-mail/common/components/FormatExpireDate';
import { ATTACHMENT_KEYS } from '@web-mail/common/components/vlistCards/MailCard/DefaultAttachment';
import { getIn18Text } from 'api';
import { getUseableImg, isMainAccount } from '@web-mail/util';
import { IMG_TYPES } from '@web-mail/common/constant';
import TransferButton from '../DownloadCard/TranferButton';
import { webTabOpen } from '@web-common/utils/utils';
import { getTrackedUrl } from '@web-common/utils/download_track';
import { reportAttachPreview } from '@web-mail/utils/mailAttach';
import { buildAttachUrl, isSafeBrowsingSupported } from '@web-common/utils/safeBrowsing';
const dataStoreApi = api.api.getDataStoreApi();
const isExpired = (expireTime) => {
    return expireTime != null && expireTime !== 0 && expireTime < Date.now();
};
const DeleteFileAlert = (expireTime) => {
    return false;
};
const forwardAtt = (downloadInfo) => {
    console.log('forwardAttforwardAtt', downloadInfo);
    const { cloudAttachment } = downloadInfo;
    if (cloudAttachment) {
        const { fileName, fileSize, fileUrl: downloadUrl, cloudIdentity, expired: expireTime } = downloadInfo;
        if (!cloudIdentity || !downloadUrl || !fileSize || !fileName) {
            return Alert.error({ title: '转发失败', content: null });
        }
        const payloadObj = {
            isCloud: true,
            expired: expireTime,
            downloadContentId: downloadUrl,
            downloadId: downloadUrl,
            fileName,
            fileSize,
            id: cloudIdentity,
            type: 'netUrl',
            fileUrl: downloadUrl,
        };
        const params = {
            mailType: 'common',
            writeType: 'common',
            extraOperate: `addCloudAtt payload:${JSON.stringify(payloadObj)}`,
        };
        mailApi.callWriteLetterFunc(params);
    }
    else {
        const { fileName, fileSize, mailId, id: partId, fileUrl } = downloadInfo;
        if (!mailId || !fileUrl || !fileSize || !fileName || !(partId || partId === 0)) {
            return Alert.error({ title: '转发失败', content: null });
        }
        const payloadObj = {
            isCloud: false,
            expired: 0,
            fileName,
            fileSize,
            fileUrl,
            type: 'fromInternalMail',
            midOfSourceMail: mailId,
            partOfSourceMail: partId,
        };
        const params = {
            mailType: 'common',
            writeType: 'common',
            extraOperate: `addNormalAtt payload:${JSON.stringify(payloadObj)}`,
        };
        mailApi.callWriteLetterFunc(params);
    }
};
const copyAtt = (downloadInfo, _account) => {
    var _a;
    const { cloudAttachment, expired } = downloadInfo;
    const acc = _account || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
    if (cloudAttachment) {
        if (expired !== 0) {
            if (expired && expired < new Date().getTime()) {
                message.error('附件已过期');
                return;
            }
        }
    }
    const copiedData = Object.assign(Object.assign({}, downloadInfo), { copyAttId: `${Math.random()}`, account: acc, timestamp: new Date().getTime() });
    console.log('copiedData', downloadInfo);
    dataStoreApi.putSync(COPIED_ATTACH_KEY, JSON.stringify(copiedData));
};
const getNewUrlWithNewToken = (account, url) => {
    try {
        if (account && url) {
            let resUrl = url;
            const hasToken = url.indexOf('_token') > -1;
            if (hasToken) {
                const newToken = mailConfApi.getTokenBySubAccount(account);
                resUrl = newToken ? url.replace(/(\?|&|%3F|%26)_token(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1_token$2' + newToken) : url;
            }
            const hasSid = url.indexOf('sid') > -1;
            if (hasSid) {
                const accountUser = systemApi.getCurrentUser(account);
                if (accountUser) {
                    const newSid = accountUser.sessionId ? accountUser.sessionId : '';
                    if (newSid) {
                        resUrl = url.replace(/(\?|&|%3F|%26)sid(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1sid$2' + newSid);
                    }
                }
            }
            return resUrl;
        }
        return url;
    }
    catch (ex) {
        console.error(`getNewUrlWithNewToken error`, ex);
        return url;
    }
};
var OperateStatus;
(function (OperateStatus) {
    OperateStatus[OperateStatus["download"] = 0] = "download";
    OperateStatus[OperateStatus["pause"] = 1] = "pause";
    OperateStatus[OperateStatus["abort"] = 2] = "abort";
    OperateStatus[OperateStatus["continue"] = 3] = "continue";
    OperateStatus[OperateStatus["reDownload"] = 4] = "reDownload";
    OperateStatus[OperateStatus["delete"] = 5] = "delete";
})(OperateStatus || (OperateStatus = {}));
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const fileApi = api.api.getFileApi();
const eventApi = api.api.getEventApi();
const httpApi = api.api.getDataTransApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
const dataTrackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const safeBrowsingApi = api.api.requireLogicalApi(apis.safeBrowsingApiImpl);
const operateMap = {
    [OperateStatus.download]: getIn18Text('XIAZAI'),
    [OperateStatus.pause]: getIn18Text('ZANTING'),
    [OperateStatus.abort]: getIn18Text('QUXIAO'),
    [OperateStatus.continue]: getIn18Text('JIXU'),
    [OperateStatus.reDownload]: getIn18Text('ZHONGSHI'),
    [OperateStatus.delete]: getIn18Text('SHANCHU'),
};
const ReadMailDownloadCard = (props) => {
    var _a;
    const { downloadInfo, cancel, noneMoreOperate, className, id: fileId, from, irrevocable = false, attachments: files = [], mid = '', fid = 1, showSaveForward = true, showCloudPreview = true, attactCardConfig = {}, _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '', source, isTpMail = false, idx = 1, mailSubject, openPreviewContainer, downloadBanned, } = props;
    const accountId = accountApi.getEmailIdByEmail(_account);
    const isFromChat = from === 'chat';
    const isFromMail = from === 'mail';
    const [fileType, setFileType] = useState('other');
    const [operateVisible, setOperateVisible] = useState(true);
    const [processVisible, setProcessVisible] = useState(false);
    const [process, setProcess] = useState('0%');
    const [fileStatus, setFileStatus] = useState('initial');
    const [fileName, setFileName] = useState('');
    const [fileSize, setFileSize] = useState(0);
    const [lockVisible, setLockModalVisible] = useState(false);
    const [operateStatus, setOperateStatus] = useState(4);
    const [cardActive, setCardActive] = useState(false);
    const [useableUrl, setUseableUrl] = useState('');
    const [safeBrowsing, setSafeBrowsing] = useState({
        remainCnt: 0,
        type: 0,
        free: false,
        loaded: false,
    });
    const safeBrowsingTokenRef = useRef(0);
    const abortRef = useRef(false);
    const imgIconRef = useRef(null);
    const autoDownloadTimer = useRef(null);
    const ifMainAccount = useMemo(() => {
        const accountId = accountApi.getEmailIdByEmail(_account);
        return isMainAccount(accountId);
    }, [_account]);
    const copyAble = useMemo(() => {
        const { cloudAttachment, expired, unDecrypted } = downloadInfo;
        if (cloudAttachment) {
            if (expired !== 0) {
                if (expired && expired < new Date().getTime()) {
                    return false;
                }
            }
        }
        if (unDecrypted === true)
            return false;
        return true;
    }, [downloadInfo, _account]);
    const hideCloudPreview = attactCardConfig.hideCloudPreview || !isFromMail || !operateVisible || fileStatus === 'downloading' || fileStatus === 'downloadFailed';
    const hideChatOpenFile = attactCardConfig.hideChatOpenFile || !inElectron || !isFromChat || (fileStatus !== 'downloaded' && fileStatus !== 'initial');
    const hideChatOpenDir = attactCardConfig.hideChatOpenDir || !inElectron || !isFromChat || fileStatus !== 'downloaded';
    const hideActionOperate = attactCardConfig.hideActionOperate ||
        attactCardConfig.hideDownload ||
        (isFromMail && fileStatus === 'initial') ||
        fileStatus === 'downloaded' ||
        (irrevocable && operateStatus === OperateStatus.abort);
    const visibleMoreOperate = !attactCardConfig.hideMoreOperate && !noneMoreOperate && !isFromChat && operateVisible && (fileStatus === 'downloaded' || fileStatus === 'initial');
    const realFileSize = fileSize > 0 ? formatFileSize(fileSize, 1024) : getIn18Text('WEIZHIDAXIAO');
    const isCloudAttachment = downloadInfo.type === 'netfolder' || !!downloadInfo.cloudAttachment;
    const fetchSafeBrowsingState = () => {
        if (!ifMainAccount)
            return;
        const myToken = ++safeBrowsingTokenRef.current;
        const midStr = mid ? String(mid) : undefined;
        const partIdStr = downloadInfo.id != null ? String(downloadInfo.id) : '';
        const cloudIdentity = downloadInfo.cloudIdentity || '';
        const accessReq = isCloudAttachment
            ? { checkType: 'CLOUD_ATT', fileKey: cloudIdentity, mid: midStr }
            : { checkType: 'NORMAL_ATT', mid: midStr, partId: partIdStr };
        Promise.all([safeBrowsingApi.getSbBase().catch(() => null), safeBrowsingApi.getSbAccess(accessReq).catch(() => null)]).then(([base, access]) => {
            var _a;
            if (myToken !== safeBrowsingTokenRef.current)
                return;
            const remainCnt = base && typeof base.remainCnt === 'number' ? base.remainCnt : 0;
            const type = Number(base === null || base === void 0 ? void 0 : base.type) || 0;
            const free = (_a = access === null || access === void 0 ? void 0 : access.free) !== null && _a !== void 0 ? _a : false;
            setSafeBrowsing({ remainCnt, type, free, loaded: true });
        });
    };
    const onSafeBrowsingClick = (e) => {
        var _a, _b;
        (_b = (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        const midStr = mid ? String(mid) : undefined;
        const fileUrl = downloadInfo.fileUrl;
        const fileNameSafe = downloadInfo.fileName;
        const url = isCloudAttachment
            ? buildAttachUrl({
                type: 'cloud',
                fileKey: downloadInfo.cloudIdentity || '',
                mid: midStr,
                fileUrl,
                fileName: fileNameSafe,
                subject: mailSubject,
            })
            : buildAttachUrl({
                type: 'attachment',
                mid: midStr,
                partId: downloadInfo.id != null ? String(downloadInfo.id) : '',
                fileUrl,
                fileName: fileNameSafe,
                subject: mailSubject,
            });
        window.open(url);
    };
    if (!downloadInfo) {
        return null;
    }
    const imgIconUrl = useMemo(() => {
        if (!IMG_TYPES.includes(fileType))
            return '';
        if (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.filePreviewUrl) {
            if (!systemApi.isElectron() && accountId) {
                return getNewUrlWithNewToken(accountId, downloadInfo.filePreviewUrl || '');
            }
            return downloadInfo.filePreviewUrl || '';
        }
        return '';
    }, [downloadInfo, fileType, accountId]);
    const showImgIcon = useMemo(() => {
        return false;
    }, [fileType, useableUrl, downloadInfo]);
    const getUseAbleIconUrl = async (url) => {
        try {
            if (!imgIconRef.current) {
                setUseableUrl('');
                return;
            }
            const useAbleUrl = await getUseableImg(url, imgIconRef.current);
            if (useAbleUrl) {
                setUseableUrl(useAbleUrl);
                return;
            }
            setUseableUrl('');
        }
        catch (error) {
            setUseableUrl('');
        }
    };
    const isExpired = (expireTime) => {
        return false;
    };
    const downloadInitial = () => {
        setOperateStatus(OperateStatus.download);
        setProcessVisible(false);
        setProcess('0%');
        setFileStatus('initial');
    };
    const actionContinue = () => { };
    const actionAbort = () => {
        console.warn('click actionAbort');
        fileApi.abortFsDownload(downloadInfo.fileUrl);
        abortRef.current = true;
        downloadInitial();
        cancel && cancel();
    };
    const openFile = async () => {
        const result = await fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account }));
        if (result && result.length > 0) {
            fileApi.openFile(Object.assign(Object.assign({}, result[0]), { _account })).then(bool => {
                if (!bool) {
                    SiriusMessage.warn({ content: getIn18Text('WUFADAKAIWEN11') }).then(() => {
                        downloadInitial();
                    });
                }
            });
        }
        else {
            SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN13') }).then(() => {
                downloadInitial();
            });
            actionAbort();
        }
    };
    const revolveDownloadReminder = (reminders) => {
        const manageReminders = reminders.map(item => {
            if (item.filePath) {
                const realFileName = window.electronLib.fsManage.getBaseName(item.filePath);
                if (realFileName) {
                    return Object.assign(Object.assign({}, item), { realFileName });
                }
            }
            return item;
        });
        systemApi.createWindowWithInitData('downloadReminder', {
            eventName: 'customNotification',
            eventData: {
                eventType: 'downloadReminder',
                reminders: manageReminders,
            },
        });
    };
    const downloadFile = async (params = {}, record = false) => {
        var _a, _b, _c;
        const trackedUrl = !(params === null || params === void 0 ? void 0 : params.slientDownload) ? getTrackedUrl(downloadInfo.fileUrl) : undefined;
        const downloadInfoWithTrack = trackedUrl ? Object.assign(Object.assign({}, downloadInfo), { fileUrlInUse: trackedUrl }) : downloadInfo;
        const saveConf = {
            noStoreData: params.repeatDownload,
            recordPerf: record && isFromMail,
            recordFileType: downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment ? 'cloud' : 'common',
            flowScene: isFromMail ? 'mail_read' : 'unknown',
            _account,
        };
        const { choosePath = true, afterSucOpenFile, defaultPath = '', afterSucOpenDir, opt } = params;
        let res;
        performanceApi.time({
            statKey: `mail_attachment_download_time`,
            statSubKey: systemApi.md5((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileUrl) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileOriginUrl) || ''),
        });
        if (choosePath) {
            res = (await fileApi.saveDownload(downloadInfoWithTrack, saveConf));
        }
        else {
            let fileInfo;
            if (typeof props.syncRequestFileInfo === 'function') {
                fileInfo = await props.syncRequestFileInfo();
            }
            else {
                fileInfo = downloadInfo;
            }
            const fileInfoWithTrack = trackedUrl ? Object.assign(Object.assign({}, fileInfo), { fileUrlInUse: trackedUrl }) : fileInfo;
            const fileTarget = defaultPath ? Object.assign(Object.assign({}, fileInfoWithTrack), { filePath: defaultPath }) : fileInfoWithTrack;
            res = (await fileApi.download(fileTarget, saveConf));
        }
        performanceApi.timeEnd({
            statKey: `mail_attachment_download_time`,
            statSubKey: systemApi.md5((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileUrl) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileOriginUrl) || ''),
        });
        if (!((_a = res) === null || _a === void 0 ? void 0 : _a.succ) && !((_b = res) === null || _b === void 0 ? void 0 : _b.success)) {
            if (res.path) {
                const errMsg = ((_c = res) === null || _c === void 0 ? void 0 : _c.errMsg) === 'download-net-error: cancelled' ? getIn18Text('YIQUXIAO') : getIn18Text('WENJIANBUCUNZAI');
                SiriusMessage.warn({ content: errMsg }).then();
                try {
                    dataTrackApi.track('pc_mail_attachment_download_failed', {
                        type: 'res_failed',
                        data: { req: downloadInfo, res },
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
            return;
        }
        if (res) {
            const { succ, fileModel } = res;
            if (succ && fileModel) {
                if (opt && ['imOpen', 'doubleClick'].includes(opt)) {
                    openFile();
                }
                const { fileName, filePath, fileType, fileSize } = fileModel;
                (fileModel === null || fileModel === void 0 ? void 0 : fileModel.filePath) &&
                    !(params === null || params === void 0 ? void 0 : params.slientDownload) &&
                    revolveDownloadReminder([
                        {
                            fileName,
                            fileType,
                            fileSize,
                            filePath: filePath,
                        },
                    ]);
                if (params === null || params === void 0 ? void 0 : params.slientDownload) {
                    const isRealSize = downloadInfo.fileSize - fileSize <= 3000;
                    if (!isRealSize) {
                        actionDelete().then(() => {
                            downloadInitial();
                            setFileSize(downloadInfo.fileSize || 0);
                        });
                    }
                }
            }
        }
    };
    const actionReDownload = () => {
        downloadFile({}, true);
    };
    const actionPause = () => { };
    const actionDelete = () => {
        return new Promise(res => {
            fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account })).then(result => {
                if (result && result.length > 0) {
                    fileApi.delFileInfo(Object.assign(Object.assign({}, result[0]), { _account }));
                }
                res();
            });
        });
    };
    const downloadThrowErrorHandler = (params = {}, err) => {
        dataTrackApi.track('pc_mail_attachment_download_failed', {
            type: 'throw_error',
            data: { req: downloadInfo, error: err },
        });
        performanceApi.timeEnd({
            statKey: `mail_attachment_download_time`,
            statSubKey: systemApi.md5((downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileUrl) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileOriginUrl) || ''),
        });
    };
    const actionDownload = async (params) => {
        if (DeleteFileAlert(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.expired))
            return;
        if (!downloadInfo || !downloadInfo.fileUrl)
            return;
        if (inElectron) {
            if (params === null || params === void 0 ? void 0 : params.repeatDownload) {
                try {
                    await actionDelete();
                    params.repeatDownload = false;
                }
                catch (error) {
                    console.warn('failed remove repeat download file', error);
                }
            }
            downloadFile(params, true).catch(e => {
                downloadThrowErrorHandler(params, e);
            });
        }
        else if (isFromChat) {
            window.open(httpApi.buildUrl(downloadInfo.fileUrl, { download: downloadInfo.fileName }));
        }
        else {
            if (accountId) {
                updateFileAttachemt(downloadInfo, accountId);
            }
            const trackedUrl = getTrackedUrl(downloadInfo.fileUrl);
            if (window.isInOtherApp) {
                fileApi.saveDownloadInOtherApp({ fileUrl: trackedUrl || downloadInfo.fileUrl, fileName: downloadInfo.fileName });
            }
            else {
                window.open(trackedUrl || downloadInfo.fileUrl);
            }
            console.log('downloadInfo', downloadInfo);
        }
    };
    const operateAction = () => {
        switch (operateStatus) {
            case OperateStatus.download:
                actionDownload();
                break;
            case OperateStatus.pause:
                actionPause();
                break;
            case OperateStatus.abort:
                actionAbort();
                break;
            case OperateStatus.continue:
                actionContinue();
                break;
            case OperateStatus.reDownload:
                actionReDownload();
                break;
            case OperateStatus.delete:
                actionDelete();
                break;
            default:
                break;
        }
    };
    const openDir = () => {
        fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account })).then(result => {
            if (result && result.length > 0) {
                fileApi.testLocalFile(Object.assign(Object.assign({}, result[0]), { _account })).then(bool => {
                    if (!bool) {
                        SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN11') }).then(() => {
                            downloadInitial();
                        });
                    }
                });
                fileApi.show(Object.assign(Object.assign({}, result[0]), { _account }));
            }
            else {
                SiriusMessage.warn({ content: getIn18Text('WEIZHAODAOWENJIAN12') }).then(() => {
                    downloadInitial();
                });
                actionAbort();
            }
        });
    };
    const openChatFile = async () => {
        if (fileStatus === 'initial') {
            await downloadFile({ choosePath: false, afterSucOpenFile: true, opt: 'imOpen' });
        }
        else {
            openFile();
        }
    };
    const updateFileAttachemt = (fileAttach, account) => {
        if (fileAttach) {
            if (fileAttach.filePreviewUrl) {
                fileAttach.filePreviewUrl = getNewUrlWithNewToken(account, downloadInfo.filePreviewUrl || '');
            }
            if (fileAttach.fileUrl) {
                fileAttach.fileUrl = getNewUrlWithNewToken(account, downloadInfo.fileUrl || '');
            }
        }
    };
    const openImgAttachment = () => {
        const onList = files
            .filter(i => i.downloadContentId === (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId) && i.fileType && IMG_TYPES.includes(i.fileType))
            .map(i => (Object.assign(Object.assign({}, i), { nonOriginal: true, downloadUrl: i.fileUrl, previewUrl: i.filePreviewUrl, name: i.fileName, size: i.fileSize })));
        const start = onList.findIndex(i => i.downloadId === downloadInfo.downloadId);
        if (!systemApi.isElectron() && accountId) {
            onList.forEach(item => {
                if (item.previewUrl) {
                    item.previewUrl = getNewUrlWithNewToken(accountId, item.previewUrl);
                }
                if (item.downloadUrl) {
                    item.downloadUrl = getNewUrlWithNewToken(accountId, item.downloadUrl);
                }
            });
        }
        ImgPreview.preview({ data: onList, startIndex: start, downloadBanned });
    };
    const cloudPreview = () => {
        reportAttachPreview({
            filename: (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) || fileName,
            mid: (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId) || '',
            _account,
        });
        if (downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment) {
            const { cloudIdentity } = downloadInfo;
            const filePreviewUrl = `${systemApi.getUrl('previewCloudAttGeneric')}?identity=${cloudIdentity}&p=web`;
            if (systemApi.isElectron() && window.electronLib) {
                systemApi.createWindowWithInitData('resources', {
                    eventName: 'initPage',
                    eventData: {
                        downloadContentId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId,
                        downloadId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId,
                        filePreviewUrl,
                        attachments: [Object.assign(Object.assign({}, downloadInfo), { filePreviewUrl, from: 'netCloudAtt' })],
                        _account,
                        fileName,
                        type: 'attachment',
                        hash: `https://resources#type=attachment&mid=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId}&fileName=${fileName}&size=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize}&downloadId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId}&downloadContentId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId}`,
                    },
                });
            }
            else {
                webTabOpen(getFeiShuUrl(filePreviewUrl));
            }
            return;
        }
        const type = downloadInfo.fileType;
        if (type && IMG_TYPES.includes(type)) {
            openImgAttachment();
            return;
        }
        if (openPreviewContainer) {
            openPreviewContainer();
            return;
        }
        if (systemApi.isElectron() && window.electronLib) {
            if (isFromMail) {
                systemApi.createWindowWithInitData('resources', {
                    eventName: 'initPage',
                    eventData: {
                        downloadContentId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId,
                        downloadId: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId,
                        filePreviewUrl: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.filePreviewUrl,
                        attachments: [downloadInfo],
                        _account,
                        fileName,
                        type: 'attachment',
                        hash: `https://resources#type=attachment&mid=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId}&fileName=${fileName}&size=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize}&downloadId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadId}&downloadContentId=${downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId}`,
                    },
                });
            }
        }
        else {
            if (accountId) {
                downloadInfo._account = accountId;
                updateFileAttachemt(downloadInfo, accountId);
            }
            const searchStrArr = ATTACHMENT_KEYS.map(k => `${k}=${encodeURIComponent((downloadInfo && downloadInfo[k]) || '')}`);
            let searchStr = searchStrArr.join('&');
            window.open(`${systemApi.getContextPath()}/attachment/?${getDingTalkSearchString(false, true)}outDownloadContentId=${encodeURIComponent(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId)}&${searchStr}`);
        }
    };
    const handleSingleClick = () => {
        if (!inElectron) {
            if (isFromChat && fileStatus === 'initial') {
                actionDownload({ choosePath: false, afterSucOpenFile: true });
            }
            else if (!hideCloudPreview && showCloudPreview) {
                cloudPreview();
            }
        }
    };
    const handleDoubleClick = async () => {
        if (inElectron) {
            if (DeleteFileAlert(downloadInfo.expired)) {
                return;
            }
            const fileInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account }));
            const isFileExist = fileInfo.length > 0 ? await fileApi.testLocalFile(Object.assign(Object.assign({}, fileInfo[0]), { _account })) : false;
            if (!isFileExist) {
                let defaultPath = await getDefaultPath();
                if (!defaultPath) {
                    return;
                }
                downloadFile({ choosePath: false, afterSucOpenFile: true, defaultPath, opt: 'doubleClick' }, true).catch(e => {
                    console.error('[mail attachment] double click download', e);
                    downloadThrowErrorHandler({ choosePath: false, afterSucOpenFile: true, defaultPath }, e);
                });
            }
            else {
                openFile();
            }
        }
        else {
            handleSingleClick();
        }
    };
    const clickCardAction = useSingleAndDoubleClick(handleSingleClick, handleDoubleClick, 500, false);
    const clickCard = () => {
        if (source === 'eml')
            return;
        clickCardAction();
    };
    const downloadStart = () => {
        setFileStatus('downloading');
        setProcessVisible(true);
        setOperateStatus(OperateStatus.abort);
    };
    const downloadSuccess = (data) => {
        setProcessVisible(false);
        setFileStatus('downloaded');
        setFileSize(data.fileSize);
    };
    const downloadFail = () => {
        setProcessVisible(false);
        setFileStatus('downloadFailed');
        setOperateStatus(OperateStatus.reDownload);
    };
    const handleFileStatus = (data) => {
        if (data) {
            if (data.fileStatus === 'downloading' && !abortRef.current) {
                downloadStart();
                setProcess(data.fileDownloadProgress * 100 + '%');
            }
            else if (data.fileStatus === 'downloaded') {
                downloadSuccess(data);
            }
            else if (data.fileStatus === 'downloadFailed') {
                if (abortRef.current) {
                    abortRef.current = false;
                }
                else {
                    downloadFail();
                }
            }
            else if (data.fileStatus === 'downloadStart') {
                downloadStart();
            }
        }
        else {
            downloadInitial();
        }
    };
    const filterSafeDownloadFilename = (filename) => {
        return filename === null || filename === void 0 ? void 0 : filename.replace(/[?:*|!$/]+/gi, '_');
    };
    const getDefaultPath = async () => {
        let defaultPath = '';
        if (isFromMail && window.electronLib) {
            const sep = window.electronLib.env.isMac ? '/' : '\\';
            try {
                const dirPath = await mailApi.mkDownloadDir('regular', { mid, fid, _account }, window.electronLib.env.isMac ? false : true);
                defaultPath = `${dirPath}${sep}${filterSafeDownloadFilename(downloadInfo.fileName)}`;
            }
            catch (ex) {
                console.error(`mkDownloadDir-catch`, ex);
                SiriusMessage.warn({ content: getIn18Text('DOWNLOAD_ATTACHMENT_ERROR') });
            }
        }
        return defaultPath;
    };
    const autoDownload = (fileInfo) => {
        autoDownloadTimer.current && clearTimeout(autoDownloadTimer.current);
        autoDownloadTimer.current = setTimeout(() => {
            if (isFromMail && (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.length) <= 0 && (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize) < 1000 ** 2 * 5) {
                getDefaultPath().then(defaultPath => {
                    if (!defaultPath)
                        return;
                    downloadFile({ slientDownload: true, choosePath: false, defaultPath });
                });
            }
        }, Math.floor(Math.random() * 10 + 2 + idx) * 1000);
    };
    const initInfo = async () => {
        const curFileType = getSuffix(downloadInfo);
        console.log('curFileTypecurFileType', curFileType, downloadInfo);
        setFileType(curFileType);
        setFileName(downloadInfo.fileName || getIn18Text('WEIZHI'));
        setFileSize(downloadInfo.fileSize || 0);
        if (inElectron) {
            const fileInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account }));
            console.log('[downloadCard] fileInfo', downloadInfo.fileName, fileInfo);
            const curFile = fileInfo[0];
            const curFileStatus = curFile === null || curFile === void 0 ? void 0 : curFile.fileStatus;
            if (curFileStatus === 'downloaded') {
                const isExits = await fileApi.testLocalFile(Object.assign(Object.assign({}, curFile), { _account }));
                if (isExits) {
                    downloadSuccess(curFile);
                }
                else {
                    fileApi.delFileInfo(Object.assign(Object.assign({}, curFile), { _account }));
                    handleFileStatus(fileApi.getFsDownloadStatus(downloadInfo.fileUrl));
                }
            }
            else {
                handleFileStatus(fileApi.getFsDownloadStatus(downloadInfo.fileUrl));
            }
            autoDownload(fileInfo);
        }
        else {
            downloadInitial();
        }
    };
    useEffect(() => {
        initInfo();
        const eventId = eventApi.registerSysEventObserver('fsDownloadNotify', {
            name: 'downloadCard_' + downloadInfo.fileUrl + Math.random().toFixed(7),
            func: ev => {
                if (ev.eventStrData === downloadInfo.fileUrl) {
                    const data = ev.eventData;
                    handleFileStatus(data);
                }
            },
        });
        return () => {
            autoDownloadTimer.current && clearTimeout(autoDownloadTimer.current);
            eventApi.unregisterSysEventObserver('fsDownloadNotify', eventId);
        };
    }, [fileId]);
    const draggable = useMemo(() => {
        return inElectron && isFromMail && fileStatus === 'downloaded';
    }, [inElectron, isFromMail, fileStatus]);
    const noDragAlert = () => {
        Alert.error({
            title: getIn18Text('FUJIANXUYAOXIAZAI'),
            content: null,
            okCancel: !0,
            cancelText: getIn18Text('QUXIAO'),
            okText: getIn18Text('XIAZAIFUJIAN'),
            onOk: () => {
                actionDownload();
            },
        });
    };
    const onDragStart = async (event) => {
        if (draggable && fileStatus !== 'downloaded') {
            noDragAlert();
            return;
        }
        console.log('[start drag]', event, downloadInfo);
        const fileInfo = await fileApi.getFileInfo(Object.assign(Object.assign({}, downloadInfo), { _account }));
        const isFileExist = fileInfo.length > 0 ? await fileApi.testLocalFile(Object.assign(Object.assign({}, fileInfo[0]), { _account })) : false;
        if (!isFileExist) {
            setFileStatus('initial');
            return;
        }
        window.electronLib.fsManage.dragFile(fileInfo[0].filePath);
    };
    const menu = () => (React.createElement(Menu, { className: styles.operateMenu },
        showCloudPreview && !hideCloudPreview && (React.createElement(Menu.Item, { key: "0", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                showSaveForward;
                cloudPreview();
            } }, getIn18Text('YULAN'))),
        fileStatus === 'downloaded' && inElectron && (React.createElement(React.Fragment, null,
            React.createElement(Menu.Item, { key: "1", className: styles.item, onClick: e => {
                    var _a;
                    (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                    openFile();
                } }, getIn18Text('DAKAIBENDIWENJIAN')),
            React.createElement(Menu.Item, { key: "2", className: styles.item, onClick: e => {
                    var _a;
                    (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                    openDir();
                } }, getIn18Text('DAKAIBENDIMULU')),
            isFromMail && !attactCardConfig.hideDownload && (React.createElement(Menu.Item, { key: "2-1", className: styles.item, onClick: e => {
                    var _a;
                    (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                    actionDownload({ repeatDownload: true, afterSucOpenDir: true });
                } }, getIn18Text('XIAZAI'))))),
        fileStatus === 'initial' && !attactCardConfig.hideDownload && (React.createElement(Menu.Item, { key: "3", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                actionDownload({ afterSucOpenDir: true });
            } }, getIn18Text('XIAZAI'))),
        showSaveForward && !attactCardConfig.hideSaveForward && (React.createElement(Menu.Item, { key: "4", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                DeleteFileAlert(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.expired);
            } },
            React.createElement(TransferButton, { cancelSave: isExpired(downloadInfo.expired), downloadInfo: downloadInfo, onChange: (value) => setLockModalVisible(value) }))),
        !!ifMainAccount && !isTpMail && !attactCardConfig.hideForward && (React.createElement(Menu.Item, { key: "5", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                forwardAtt(downloadInfo);
            } }, getIn18Text('ZHUANFA'))),
        !!copyAble && !attactCardConfig.hideCopy && (React.createElement(Menu.Item, { key: "6", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                copyAtt(downloadInfo, _account);
            } }, getIn18Text('FUZHI'))),
        ifMainAccount &&
            !attactCardConfig.hideSafeBrowsing &&
            safeBrowsing.loaded &&
            safeBrowsing.type > 0 &&
            isSafeBrowsingSupported({ fileName: downloadInfo.fileName, fileSize: downloadInfo.fileSize }) && (React.createElement(Menu.Item, { key: "safe_browsing", className: classnames(styles.item, { [styles.safeBrowsingDisabled]: safeBrowsing.remainCnt === 0 && safeBrowsing.free !== true }), disabled: safeBrowsing.remainCnt === 0 && safeBrowsing.free !== true, onClick: onSafeBrowsingClick },
            React.createElement("span", { className: styles.safeBrowsingRow },
                React.createElement("span", { className: styles.safeBrowsingLeft }, getIn18Text('安全浏览')),
                React.createElement("span", { className: styles.safeBrowsingCount },
                    getIn18Text('剩余 {0} 次', { 0: Math.max(safeBrowsing.remainCnt, 0) }),
                    safeBrowsing.free && getIn18Text('BENCILIULBKCCS')))))));
    const emlMenu = () => (React.createElement(Menu, { className: styles.operateMenu },
        fileStatus === 'downloaded' && inElectron && (React.createElement(Menu.Item, { key: "2-1", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                actionDownload({ repeatDownload: true });
            } }, getIn18Text('XIAZAI'))),
        fileStatus === 'initial' && (React.createElement(Menu.Item, { key: "3", className: styles.item, onClick: e => {
                var _a;
                (_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                actionDownload();
            } }, getIn18Text('XIAZAI')))));
    const onCardMouseLeave = () => {
        setCardActive(false);
    };
    const onCardMouseEnter = () => {
    };
    return (React.createElement(Dropdown, { overlay: !visibleMoreOperate ? React.createElement(React.Fragment, null) : source === 'eml' ? emlMenu : menu, trigger: ['contextMenu'] },
        React.createElement(Dropdown, { overlay: !visibleMoreOperate || inElectron ? React.createElement(React.Fragment, null) : source === 'eml' ? emlMenu : menu, trigger: ['hover'], onVisibleChange: visible => {
                if (visible && source !== 'eml') {
                    fetchSafeBrowsingState();
                }
            } },
            React.createElement("div", { className: classnames(styles.attachmentCard, className, {
                    [styles.error]: fileStatus === 'downloadFailed',
                    [styles.isChat]: isFromChat,
                    [styles.isFromMail]: isFromMail,
                    [styles.isActive]: isFromMail && cardActive,
                }), onMouseLeave: onCardMouseLeave, onMouseEnter: onCardMouseEnter, draggable: draggable, onDragStart: onDragStart },
                React.createElement("div", { className: styles.content, onClick: clickCard },
                    downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment ? React.createElement("div", { className: styles.netFolderTag }, getIn18Text('YUNFUJIAN')) : '',
                    React.createElement("img", { ref: imgIconRef, className: styles.infoImg, style: showImgIcon ? { display: 'block' } : { display: 'none' } }),
                    !showImgIcon ? (React.createElement("div", { className: styles.infoIcon },
                        React.createElement(IconCard, { type: fileType, height: "18", width: "18" }))) : (React.createElement(React.Fragment, null)),
                    React.createElement("div", { className: styles.infoRight },
                        React.createElement("div", { className: classnames(styles.info, { [styles.cloudInfo]: downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment }) },
                            React.createElement("div", { className: styles.name, title: decodeAttFileName(fileName), dangerouslySetInnerHTML: {
                                    __html: decodeAttFileName(downloadInfo.fileHandledName || fileName),
                                } }))),
                    React.createElement("div", { className: styles.operate },
                        React.createElement("div", { className: styles.operateItem },
                            React.createElement("div", { className: classnames(styles.size, { [styles.operateGap]: !inElectron }) },
                                realFileSize,
                                downloadInfo.type === 'netfolder' || downloadInfo.cloudAttachment ? React.createElement(React.Fragment, null,
                                    " | ",
                                    React.createElement(FormatExpiredDate, { date: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.expired })) : ''),
                            React.createElement("div", { className: classnames(styles.itemBox, {
                                    [styles.mail]: isFromMail,
                                }) },
                                React.createElement("span", { className: styles.itemOpe, hidden: hideChatOpenFile, onClick: e => {
                                        e.stopPropagation();
                                        openChatFile();
                                    } }, getIn18Text('DAKAI')),
                                React.createElement("span", { className: styles.itemOpe, hidden: hideChatOpenDir, onClick: e => {
                                        e.stopPropagation();
                                        openDir();
                                    } }, getIn18Text('DAKAIWENJIANJIA')),
                                React.createElement("span", { className: styles.itemOpe, hidden: hideActionOperate, onClick: e => {
                                        e.stopPropagation();
                                        operateAction();
                                    } }, operateMap[operateStatus]),
                                visibleMoreOperate && inElectron && (React.createElement("div", { className: styles.itemOpe },
                                    React.createElement(Dropdown, { overlay: source === 'eml' ? emlMenu : menu, placement: "bottomCenter", trigger: ['click'], onVisibleChange: visible => {
                                            setCardActive(visible);
                                        }, getPopupContainer: () => document.body },
                                        React.createElement("div", { onClick: e => e.stopPropagation() },
                                            React.createElement(IconCard, { type: "more", className: styles.moreBtn }))))))))),
                React.createElement("div", { className: styles.processBox, hidden: !processVisible },
                    React.createElement("div", { className: styles.process, style: { width: process } })),
                React.createElement(Modal, { visible: lockVisible, okText: getIn18Text('QIANWANGJIESUO'), cancelText: getIn18Text('ZHIDAOLE'), onCancel: () => setLockModalVisible(false), closable: false, onOk: () => systemApi.openNewWindow('https://qiye.163.com', false) },
                    React.createElement("h2", null, getIn18Text('GERENKONGJIANYI')),
                    React.createElement("div", null, getIn18Text('KEQIANWANGWANGYI')))))));
};
export default ReadMailDownloadCard;
